/**
 * Move content to mobile
 */
function moveToMobile(){
    const contents = document.querySelectorAll('div[data-target-mobile]');

    contents.forEach((item)=>{
        const targetMobileId = item.getAttribute('data-target-mobile');
        const htmlData = item.innerHTML;
        item.innerHTML = '';
        document.getElementById(targetMobileId).innerHTML = htmlData;
    });
}

window.addEventListener('DOMContentLoaded',function () {
    if(window.innerWidth <= 1024){
        moveToMobile();
    } 

    if (
        document.querySelector(".mobile-cart a") &&
        document.querySelector("cart-drawer")
    ) {
        document
            .querySelector(".mobile-cart a")
            .addEventListener("click", function (e) {
                this.setAttribute("href", "javascript:void(0)");
                document
                    .querySelector("cart-drawer")
                    .classList.toggle("active");
            });

        document
            .querySelector(".sticky-cart")
            .addEventListener("click", function (e) {
                this.setAttribute("href", "javascript:void(0)");
                document
                    .querySelector("cart-drawer")
                    .classList.toggle("active");
            });
    }

    moveSizeChartToBody();

  /** Read more description collection **/

  if(document.querySelector('.collection-hero__description')){
    const collectionDesHeight = document.querySelector('.collection-hero__description').offsetHeight;

    if(collectionDesHeight >= 190){
      document.querySelector('.collection-hero__description').classList.add('has-readmore');
  
      document.querySelector('.readmore-description button').addEventListener('click', function(e) {
         this.closest('.collection-hero__inner').classList.toggle('active')
      });    
    }
  }

  
});

/**
 * Change form customer sidebar
 */
document.querySelectorAll('.change-form-customer').forEach((element) => {
    element.addEventListener('click', (event) => changeFormCustomer(event, element));
});

function changeFormCustomer(event, element){
    event.preventDefault();
    const modalTitle = element.getAttribute('data-form-title');
    const modalTarget = element.getAttribute('data-form-customer-target');
    const currentModal = element.closest('tapita-modal-content');
    const formCustomers = currentModal.querySelectorAll('.customer-form');

    currentModal.querySelector('.modal-title').innerHTML = modalTitle;

    formCustomers.forEach((form)=>{
        form.style.display = 'none';
    });

    document.getElementById(modalTarget).style.display = 'block';
}

/**
 * Set top position modal search
 */
window.addEventListener('DOMContentLoaded',function () {
    const headerDesktopHeight = document.querySelector('.header-desktop').offsetHeight
    document.querySelector('.header-desktop .search-modal').style.top = headerDesktopHeight + 'px';
});
/**
 * Section lady load
 */
function secsionLadyLoad(){
    const section = document.querySelector('[data-ladyload="true"]');

    if(section){
        const elementId = section.getAttribute('id');
        const sectionId = elementId.substring(16);
        const urlFetchSectionId = window.location.hostname + '?section_id=' + sectionId;

        if(!section.classList.contains('loaded')){
            section.classList.add('loaded')

            fetch(urlFetchSectionId)
            .then((response) => response.text())
            .then((responseText) => {
                const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                setTimeout(() => {
                    sectionElement = responseHTML.querySelector('section[id^="shopify-section-"]');

                    section.innerHTML = sectionElement.innerHTML;    
                    section.querySelectorAll('script')
                    .forEach((oldScriptTag) => {
                        const newScriptTag = document.createElement('script');
                        Array.from(oldScriptTag.attributes).forEach((attribute) => {
                            newScriptTag.setAttribute(attribute.name, attribute.value);
                        });
                        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                    });

                    section.setAttribute('data-ladyload','false');
                }, 50);        
            })
            .finally(() => {
            
            });
        }
    }

}

/*bgaddTptTrdTM*/function tptmakeidfspdt(length) { var result = ""; var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"; var charactersLength = characters.length; for (var i = 0; i < length; i++) { result += characters.charAt(Math.floor(Math.random() * charactersLength)); } return result; } var tptSpdTId = tptmakeidfspdt(50); function addTptTrdTM() { var tpPBCtn = document.getElementsByTagName("main"); if (tpPBCtn.length && tpPBCtn[0] && !document.getElementById(tptSpdTId)) { var tptTmt = document.createElement("div"); tptTmt.onclick = function () { window.location.href = ('https://' + 'apps' + '.' + 'shopify.com/' + 'google' + '-seo' + '-schema-' + 'meta' + '-data'); }; tptTmt.setAttribute("id", tptSpdTId); tptTmt.style.margin = "10px auto"; tptTmt.style.display = "block"; tptTmt.style.width = "200px"; tptTmt.style.zIndex = 9999999; tptTmt.style.position = "relative"; var tptImg = document.createElement("img"); tptImg.src = "data:image/png;base64,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"; tptImg.style.height = "46px"; tptImg.style.width = "200px"; tptTmt.appendChild(tptImg); var newcssTagStyle = "#" + tptSpdTId + "{display: block !important;}"; var styleTag = document.createElement("style"); styleTag.type = "text/css"; styleTag.appendChild(document.createTextNode(newcssTagStyle)); tpPBCtn[0].prepend(tptTmt); tpPBCtn[0].prepend(styleTag); } else { window.setTimeout(addTptTrdTM, 1000); } } setTimeout(() => { if (document && document.documentElement && document.documentElement.innerHTML && document.documentElement.innerHTML.includes && !document.documentElement.innerHTML.includes('t=tapita-seo-script-tags')) addTptTrdTM() }, 3000);/*edaddTptTrdTM*/

document.addEventListener('scroll', (event) => {
    secsionLadyLoad();
});

/**
 * Dropdown megamenu mobile
 */

class DropdownMegamenuMobile extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.showDropdownMegamenuMobile.bind(this));
  }

  showDropdownMegamenuMobile(){
    const btnDropdown = this;
    const menuItem = btnDropdown.closest('.menu-item');
    menuItem.classList.add('show-dropdown');

    setTimeout(function() {
        menuItem.classList.add('animate');
    }, 10);
  }

}

customElements.define('dropdown-megamenu-item', DropdownMegamenuMobile);


class BackDropdownMegamenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.backToMegamenuItem.bind(this));
  }

  backToMegamenuItem(){
    const btnBack = this;
    const menuItem = btnBack.closest('.menu-item');
    menuItem.classList.remove('animate');

    setTimeout(function() {
        menuItem.classList.remove('show-dropdown');
    }, 300);
  }

}

customElements.define('back-to-item', BackDropdownMegamenu);

/**
 * Sticky product add to cart
 */
class StickyProductAddToCart extends HTMLElement {
  constructor() {
    super();
    
    const btnChangeQty = this.querySelectorAll('.quantity__button');
    const btnStickyAddCart = this.querySelector('.sticky-add-cart');

    btnStickyAddCart.addEventListener('click', this.addToCart);

    btnChangeQty.forEach((btn)=>{
        btn.addEventListener('click', this.changeQty);
    })
  }

  changeQty(){
    const inputQty = this.closest('tapita-quantity-input').querySelector('[name="quantity"]');
    const mainInput = document.querySelector('product-info quantity-input [name="quantity"]');
    let stickyInputValue = parseInt(inputQty.value);

    if(this.getAttribute('name') == 'plus'){
        stickyInputValue = stickyInputValue + 1;
    } else{
        if(parseInt(inputQty.value) > 1){
            stickyInputValue = stickyInputValue - 1;
        }
    }

    inputQty.value = stickyInputValue;
    mainInput.value = stickyInputValue;

  }

  addToCart(){
    this.classList.add('loading');
    document.querySelector('product-info product-form .product-form__submit').click();
  }
}

customElements.define('tapita-quantity-input', StickyProductAddToCart);

function showStickyAddCart(){
    let offsetTop = document.querySelector('product-info product-form').offsetTop;
    let documentTop = document.documentElement.scrollTop;
    const stickyAddCart = document.querySelector('.sticky-button-cart');
    
    if(documentTop > offsetTop + 400){
        stickyAddCart.classList.add('active');
        document.body.classList.add('show-sticky-add-cart');
    } else {
        stickyAddCart.classList.remove('active');
        document.body.classList.remove('show-sticky-add-cart');
    }
}

document.addEventListener('scroll', (event) => {
    if(document.querySelector('.sticky-button-cart')){
        showStickyAddCart();
    }
});

/**
 * Move modal sizechart to body
 */

function moveSizeChartToBody(){
    if(document.querySelector('[id="modal-size-chart"]')){
        document.body.append(document.querySelector('[id="modal-size-chart"]'));
    }
}